import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import DialogModal from 'tradera-components/dialog/dialog-modal';
import { LeaveFeedback } from './leave-feedback';
import { ROLES } from './constants';
import { closeModal } from 'tradera-state/ui/actions';
import { useTranslator } from 'tradera-lang/translate';
import CloseIcon from '@tradera/blueprint/theme/icons2/close.svg?jsx';
import styles from './single-feedback-dialog.module.scss';

export const SINGLE_FEEDBACK_DIALOG_ID = 'single-feedback-dialog';

export const SingleFeedbackDialog = ({
    onDismiss = () => {},
    onDone,
    isSeller
}) => {
    const dispatch = useDispatch();
    const { t } = useTranslator();
    const { currentModal, currentModalData } = useSelector(
        state => state.ui.modals
    );

    if (currentModal !== SINGLE_FEEDBACK_DIALOG_ID) {
        return null;
    }
    return (
        <DialogModal
            className={`${styles.dialog} flex-column position-relative`}
            mobileFullscreen={true}
            onDismiss={() => dispatch(closeModal())}>
            <>
                <div
                    className="position-absolute"
                    style={{ top: '10px', right: '10px', zIndex: 1 }}>
                    <button
                        className="btn btn-round"
                        onClick={() => dispatch(closeModal())}>
                        <CloseIcon className="icon icon-md" />
                    </button>
                </div>
                <h2 className="heading-berlin text-center text-styled my-3">
                    {t(
                        isSeller
                            ? 'leaveFeedback_rateBuyer_title'
                            : 'leaveFeedback_rateSeller_title'
                    )}
                </h2>
                <LeaveFeedback
                    isInMultipleFeedbacksContext={false}
                    role={isSeller ? ROLES.SELLER : ROLES.BUYER}
                    transactionIds={
                        currentModalData.transactionIds
                            ? currentModalData.transactionIds
                            : [currentModalData.transactionId]
                    }
                    onDismiss={() => {
                        dispatch(closeModal());
                        onDismiss();
                    }}
                    onDone={submittables => {
                        dispatch(closeModal());
                        onDone({
                            submittables,
                            purchaseOrderId: currentModalData.purchaseOrderId,
                            transactionId: currentModalData.transactionId
                        });
                    }}
                />
            </>
        </DialogModal>
    );
};
